import { combineEpics } from 'redux-observable'
import * as institution_epics from './institutions'


export default combineEpics(
  institution_epics.initiateFetchInstitutionsEpic,
  institution_epics.fetchInstitutionsEpic,
  institution_epics.fetchingInstitutionsEpic,

  institution_epics.fetchInstitutionEpic,
  institution_epics.fetchingInstitutionEpic
);



/** WEBPACK FOOTER **
 ** ./src/epics/root_epic.js
 **/